import { render, staticRenderFns } from "./KedvezmenyekB1.vue?vue&type=template&id=7abb72d0&"
import script from "./KedvezmenyekB1.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports